import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import clsx from 'clsx';

import Icon from 'sharedComponents/Icon';
import SecondaryNav from 'sharedComponents/SecondaryNav';
import SocialButtons from 'sharedComponents/SocialButtons';
import { currentYear } from 'utils/dateHelpers';
import useStyles from './useStyles';

const Footer = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.commitment}>
          <Typography className={classes.sectionTitle} variant="h6">
            {t('components.Footer.bundleCommitment')}
          </Typography>
          <Typography className={clsx(classes.text, classes.description)}>
            {t('components.Footer.description')}
          </Typography>
          <Typography className={classes.text}>{t('components.Footer.copyright', { currentYear })}</Typography>
        </div>
        <div className={classes.nav}>
          <Typography className={classes.sectionTitle} variant="h6">
            {t('components.Footer.navTitle')}
          </Typography>
          <SecondaryNav />
        </div>
        <div className={classes.contacts}>
          <Typography className={classes.sectionTitle} variant="h6">
            {t('components.Footer.contactUs')}
          </Typography>
          <div className={classes.sectionContent}>
            <Typography
              className={clsx(classes.address, classes.text)}
              dangerouslySetInnerHTML={{
                __html: t('components.Footer.address'),
              }}
            />
            <Typography className={clsx(classes.phone, classes.text)}>{t('settings.contacts.phone')}</Typography>
            <Typography className={classes.text}>{t('settings.contacts.email')}</Typography>
            <div className={classes.socialButtons}>
              <SocialButtons />
            </div>
          </div>
        </div>
        <div className={classes.logo}>
          <Icon name="ehoLogo" className={classes.icon} />
        </div>
      </div>
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/sharedComponents/Footer/Footer.js